import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LiquorIcon(props: IconProps) {
    return <Icon {...props} iconKey={"liquor"}/>
}
